import { Toolbar } from 'primereact/toolbar';
import SettingUpNavBlock from '../components/NavBlocks/SettingUpNavBlock';

const SettingUp = () => {
  return (
    <div className="grid nc_content-frame nc_page-inner">
      <Toolbar role="section" className="col-10 col-offset-1 nc_page-header" center={<h1>Set up</h1>} />
      <div className="col-10 col-offset-1 flex flex-column align-items-center">
        <div className="nc_block">
          <SettingUpNavBlock></SettingUpNavBlock>
        </div>
      </div>
    </div>
  );
};

export default SettingUp;
